/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';
import { QuizIcon } from '@coursera/cds-icons';

import { getHeadingStyle } from 'bundles/unified-description-page-common/components/modules/product-overview/details/Details';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

import _t from 'i18n!nls/xdp';

interface Props {
  itemCounts: ConsumerSpecializationPageFieldsFragment['itemCounts'];
}

const styles = {
  itemTitle: css`
    padding: var(--cds-spacing-150) 0 0 0;
    line-height: 24px;
  `,
  icon: css`
    display: block;
  `,
};

function ItemCountsDetailItem({ itemCounts }: Props) {
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  return (
    <React.Fragment>
      <QuizIcon size="large" css={styles.icon} />
      <Typography2 variant={getHeadingStyle(enableXDPRedesign)} css={styles.itemTitle} component="div">
        <FormattedHTMLMessage
          message={_t('{count} {count, plural, =1{ practice exercise } other { practice exercises }}')}
          count={itemCounts?.totalAssignmentCount}
        />
      </Typography2>
    </React.Fragment>
  );
}

export default ItemCountsDetailItem;
